import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';

import './styles/index.css';
import 'react-select/dist/react-select.css';

import App from './App';
import cvtApp from './redux/reducers';


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
	cvtApp,
	composeEnhancers(applyMiddleware(ReduxThunk))
);

render(
	<Provider store={store}>
	  <App />
	</Provider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js